import { Link } from '@inertiajs/react'

const NAV_ITEMS = [
  { key: 'home', label: 'Home', href: '/company' },
  { key: 'profile', label: 'Profile', href: '/company/profile/edit' },
  { key: 'positions', label: 'Positions', href: '/company/positions' },
] as const

type NavKey = (typeof NAV_ITEMS)[number]['key']

interface CompanyWorkspaceNavProps {
  active?: NavKey
}

export function CompanyWorkspaceNav({ active }: CompanyWorkspaceNavProps) {
  return (
    <nav className="mb-5 flex gap-5">
      {NAV_ITEMS.map((item) => (
        <Link
          key={item.key}
          href={item.href}
          className={
            active === item.key
              ? 'font-sans text-[13px] font-medium text-foreground'
              : 'font-sans text-[13px] text-muted-foreground transition-colors hover:text-foreground'
          }
        >
          {item.label}
        </Link>
      ))}
    </nav>
  )
}
